<template>
  <div>
    <div>
      <vx-card>
        <vs-row vs-justify="center" class="mb-4">
          <h3>You are almost done!</h3>
        </vs-row>
        <vs-row>
          <p v-if="meetingInstance.meeting.type == 'Weekly'">
            Good job completing this week's venue meeting! If you have any other topics that need our attention, please
            share your feedback with us. If not, enjoy your week and go make some unforgetable moments for our guests.
          </p>
          <p v-else>
            Good job, you have now been through the whole agenda! If you have any other topics you feel that
            needs attention, please say so. Moreover you are kindly asked to fill out your ratings of how well
            you feel supported by your fuel functions.
          </p>
        </vs-row>
      </vx-card>
    </div>

    <vs-row>
      <!--       <vs-col vs-w="4" class="py-4 pr-2">
        <vx-card>
          <vs-row vs-justify="center" class="mb-4">
            <h3 class="text-center">How well do you feel suppored by your fuel functions?</h3>
          </vs-row>
          <vs-row>
            <Question
              v-for="question in step.fuelFunctionQuestions"
              :key="question.id"
              :question="question"
              :isEditable="meetingInstance.isEditable"
            />
          </vs-row>
        </vx-card>
      </vs-col> -->
      <!--       <vs-col vs-w="6" class="py-4 px-2">
        <vx-card>
          <vs-row vs-justify="center" class="mb-4">
            <h3 class="text-center">Venue pulse</h3>
          </vs-row>
          <vs-row>
            <Question
              v-for="question in step.venuePulseQuestions"
              :key="question.id"
              :question="question"
              :isEditable="meetingInstance.isEditable"
            />
          </vs-row>
        </vx-card>
      </vs-col> -->
      <vs-col vs-w="12" class="py-4 pl-2">
        <vx-card>
          <vs-row vs-justify="center" class="mb-4">
            <h3 class="text-center">Please elaborate on your submitted answers</h3>
          </vs-row>
          <vs-row>
            <Question v-for="question in step.elaborationQuestions" :key="question.id" :question="question"
              :isEditable="meetingInstance.isEditable" />
          </vs-row>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Question from "../MeetingQuestion.vue";

export default {
  props: ["step", "meetingInstance"],
  components: { Question },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
.con-vs-slider {
  min-width: 180px;
}
</style>

